import React from "react";
import ME from "../../assets/about_img.png";
import { MdWorkOutline } from "react-icons/md";
import { FaProjectDiagram } from "react-icons/fa";
import { FaAward } from "react-icons/fa";
import "./about.css";

const About = () => {
  return (
    <section id="about">
      <h5> Get to Know </h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__img">
            <img src={ME} alt="" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <MdWorkOutline className="about__icon" />
              <h5>Experience</h5>
              <small>+2 Internships</small>
            </article>

            <article className="about__card">
              <FaProjectDiagram className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Projects</small>
            </article>

            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Certifications</h5>
              <small>8+ Certifications</small>
            </article>
          </div>

          <p>
            I am an M2 student in Artificial Intelligence and Computer Science,
            with hands-on experience in Python, SQL, machine learning, and deep
            learning models. I am a motivated, curious, and creative individual,
            eager to continuously learn and apply AI solutions to real-world
            problems.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
